if($('.type-detail').length){
    if($('.product-top .flag-tip').length){
        $('.p-image-wrapper').append('<sdiv class="buterflyDreamer"><span class="dreamer">Motýlek Snílek<br> doporučuje!</span></div>')
    }   
}